import { FormatRegistry } from "@sinclair/typebox";
import { Value } from "@sinclair/typebox/value";
const dateTimePattern = /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/;
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const validDateTimes = new Set();
function validDateTime(value) {
    if (validDateTimes.has(value))
        return true;
    if (!dateTimePattern.test(value) || !Number.isFinite(Date.parse(value)))
        return false;
    // 只缓存已验证的短时间戳；HTTP 与事件重复校验复用结果，数量和单值长度均有界。
    if (value.length <= 64) {
        if (validDateTimes.size === 128)
            validDateTimes.delete(validDateTimes.values().next().value);
        validDateTimes.add(value);
    }
    return true;
}
// TypeBox 的 Value 校验器不会隐式加载 format。这里显式注册协议实际使用的两种格式，
// 使浏览器、worker 和服务端 Adapter 对生成 schema 的解释一致。
FormatRegistry.Set("date-time", validDateTime);
FormatRegistry.Set("email", (value) => value.length <= 254 && emailPattern.test(value));
export class ContractValidationError extends Error {
    issues;
    constructor(issues) {
        super("协议数据未通过运行时校验");
        this.name = "ContractValidationError";
        this.issues = issues;
    }
}
export function parseContract(schema, input) {
    if (!Value.Check(schema, input)) {
        const issues = [...Value.Errors(schema, input)].map((error) => `${error.path || "/"}: ${error.message}`);
        throw new ContractValidationError(issues);
    }
    return input;
}
//# sourceMappingURL=schema-helpers.js.map